<template>
  <div class="publicPay">
    <div class="safe">
      <div class="payBox">
        <div class="title">
          选择支付方式
        </div>
        <!-- 价格 -->
        <div class="price">
          &yen;{{cardInfo.price}}
        </div>
        <!-- 联合会员名 -->
        <div class="name">
          {{cardInfo.title}}
        </div>
        <!-- 支付方式 -->
        <div class="paytype">
          <div class="payItem" @click="radio('5')">
            <div class="icon_type">
              <img src="http://images.zhibo.tv/2021/0319/orCode-weixin.png" alt="">
              <div class="itemName">微信</div>
            </div>
            <span :class="payType === '5' ? 'radio radio_checked' : 'radio'"></span>
          </div>
          <div class="payItem" @click="radio('6')">
            <div class="icon_type">
              <img src="http://images.zhibo.tv/2021/0513/icon_alipay@2x.png" alt="">
              <div class="itemName">支付宝</div>
            </div>
            <span :class="payType === '6' ? 'radio radio_checked' : 'radio'"></span>
          </div>
        </div>
        <!-- 支付按钮 -->
        <div class="payBtn" @click="gotoPay">
          立即支付
        </div>
        <!-- 关闭按钮 -->
        <div class="icon_close" @click="doClose">
          <img src="https://images.zhibo.tv/2021/0521/icon_cancel@3x.png" alt="">
        </div>
      </div>
    </div>
    <span class="toast" v-if="toastIsShow">{{toastInfo}}</span>
  </div>
</template>

<script>
export default {
  props: ['payDialogIsShow', 'infoData', 'cardInfo', 'token'],
  name: '',
  data () {
    return {
      isShow: this.buyDialogIsShow,
      payType: '5',
      payinfo: { price: '23.00', name: '央视体育VIP+中国体育联合会员·月卡' },
      paytypes: [{ icon: 'http://images.zhibo.tv/2021/0319/orCode-weixin.png', name: '微信', isChecked: true },{ icon: 'http://images.zhibo.tv/2021/0513/icon_alipay@2x.png', name: '支付宝', isChecked: false }],
      toastIsShow: false,
      toastInfo: ''
    };
  },
  computed: {
  },
  watch: {
    isShow (val) {
      this.buyDialogIsShow = val;
    }
  },
  created () {
    console.log(this.infoData, 'infoData')
  },
  methods: {
     // 关闭
    doClose () {
      // 触发父组件中的dialogVisibleEvent事件，并传递参数
      this.$emit('changePayDialogShow', false);
    },
    // 支付类型切换
    radio(type) {
     this.payType = type
    },
    // 支付
    async gotoPay() {
      let params = 'token=' + this.token + '&cardId=' + this.infoData.id + '&priceId=' + this.cardInfo.id + '&payType=' + this.payType + '&bagType=2'
      const { data } = await this.$api.getPayAndroid(params)
      if (data.status === '200') {
        try {
          window.LiveAppJS.buyVip(data.data, this.infoData.id);
        } catch (error) {
          console.log(error, data.data, this.infoData.id);
        }
        this.$emit('changePayDialogShow', false);
      } else {
        this.showToast(data.data)
      }
      // // 关闭支付弹窗
      // this.$emit('changePayDialogShow', false);
      // // 打开支付成功弹窗
      // this.$emit('changeSuccessDialogShow', true);
    },
    // toast提示
    showToast(val) {
      this.toastInfo = val
      this.toastIsShow = true
      setTimeout(() => {
        this.toastIsShow = false
      }, 2000)
    },
  }
}
</script>

<style lang='less' scoped>
.publicPay {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  .safe {
    padding-bottom: constant(safe-area-inset-bottom); //兼容IOS < 11.2
    padding-bottom: env(safe-area-inset-bottom); //兼容IOS > 11.2
  }
  .payBox {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100vw;
    // height: 6.56rem;
    border-radius: 0.24rem 0.24rem 0 0;
    background: #fff;
    padding: 0.4rem 0.3rem;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .title {
      margin-bottom: 0.42rem;
      font-size: 0.34rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #222222;
      line-height: 0.48rem;
    }
    .price {
      font-size: 0.88rem;
      font-family: BebasNeue;
      color: #222222;
      line-height: 1.24rem;
    }
    .name {
      margin-bottom: 0.6rem;
      font-size: 0.24rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 0.33rem;
    }
    // 支付方式
    .paytype {
      width: 100%;
      margin-left: 0.1rem;
      .payItem {
        display: flex;
        align-items: flex-start;
        align-items: center;
        // padding-bottom: 0.25rem;
        // border-bottom: 0.14vw solid #e5e5e5;
        height: 1rem;
        .icon_type {
          flex: 1;
          width: 0.44rem;
          height: 0.44rem;
          margin-right: 10px;
          display: flex;
          img {
            display: block;
            width: 0.44rem;
            height: 0.44rem;
          }
        }
        .itemName {
          font-size: 0.28rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 0.4rem;
          margin-left: .1rem;
        }
        .radio {
          width: .36rem;
          height: .36rem;
          opacity: 0.99;
          border: .02rem solid #BDBDBD;
          border-radius: 100%;
          cursor: pointer;
          box-sizing: border-box;
        }
        .radio_checked {
          background: url(http://images.zhibo.tv/2021/0513/radio-icon.png) no-repeat;
          background-size: 100%;
          border: none;
          cursor: auto;
        }
      }
    }
    .payBtn {
      width: 6.9rem;
      height: 0.88rem;
      margin-top: 0.7rem;
      background: url('../assets/icon/btns@2x.png') no-repeat center;
      background-size: 100%;
      font-size: 0.32rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #984b26;
      text-align: center;
      line-height: 0.88rem;
    }
    // 关闭按钮
    .icon_close {
      position: absolute;
      width: 0.32rem;
      height: 0.32rem;
      right: 0.32rem;
      top: 0.32rem;
      img {
        display: block;
        width: 0.32rem;
        height: 0.32rem;
      }
    }
  }
  .toast {
    z-index: 30;
    display: inline-block;
    white-space: nowrap;
    height: 20px;
    position: fixed;
    margin: auto;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: rgba(0, 0, 0, 0.8);
    border-radius: 4px;
    padding: 10px 20px;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: rgba(255, 255, 255, 1);
    text-align: center;
  }
}
</style>
